<template>
<div id="billing-order-action-page-scoped-container">
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-py-sm">
            <div v-if="nmInterface === 'gravar'" class="crud-title">
              <translate>NEW_REGISTRATION</translate>
            </div>
            <div v-else-if="nmInterface === 'alterar'" class="crud-title">
              <translate>UPDATE</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-px-lg">
            <span v-if="elements.length == 1">
              <jt-dynamic-form
                ref="dynamicForm"
                :inputs="prepareInputs(elements[0].inputs)"
                :relacionamentos="elements[0].relacionamentos"
                :model="elements[0].dadosForm"
                :interface="elements[0].nmInterface"
                form-class="form dynamic"
                @search-found="selections"
                @composition-button-click="actionButtonComposition"
              />

              <label class="total-value" style="margin-right: 40px">TOTAL {{totalValue()}}</label>
            </span>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <div
      v-if="forms[0] && forms[0].buttons.length > 0"
      class="row full-width q-col-gutter-lg justify-center q-pt-lg"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm">
          <translate>CLEAN</translate>
        </q-btn>
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        class="col-lg-2 col-md-3"
        :class="{'bt-cancelar': button.name === 'btCancelarAlterar' }"
      >
        <q-btn class="full-width" color="info" @click="actionButton(button)">
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
    <billing-order-dialog-delete-order-item
      @on-ok-click="onOkClickDeleteOrderItem"
      ref="modalDeleteOrderItem"
    />
    <modal
      ref="splitModal"
      :show="flSplitModal"
      :forms="formsModalSplit"
      :label="this.$gettext('DEFINITION_OF_GROUPS')"
    >
      <template slot="form" ref="modal" slot-scope="dateModal">
        <crud-form
          ref="crudForm"
          :form="formsModalSplit[0]"
          :model="formsModalSplit[0].dadosForm"
          @action-click="dateModal.actionClick"
        >
          <compositions>
            <composition
              slot="billingOrderItems"
              slot-scope="dados"
              v-bind="dados"
              @action-click="actionButtonModal"
              multiselect
            >
            </composition>
          </compositions>
        </crud-form>
        <div class="btSaveSplit">
      <q-btn
        color="info"
        :name="formsModalSplitButtons[0].name"
        @click="saveSplit(formsModalSplitButtons[0])"
      >
        {{ formsModalSplitButtons[0].label }}
      </q-btn>
      </div>
      </template>
    </modal>

    <billing-order-item
      :v-if="showBillingOrderItemModal"
      ref="billingOrderItemModal"
      :form="billingOrderItemForm"
      :composicaos="elements[0].dadosForm.billingOrderItems"
      :nr-linha-selecionada="billingOrderItemForm.nrLinhaSelecionada"
      :fl-composicao-alteracao="editMode"
      @onAddSuccess="onAddBillingOrderItemSuccessHandler"
      @onEditSuccess="onEditBillingOrderItemSuccessHandler"
    />
  </div>
</div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { repository, messageBox } from 'jtech'
import { JtDynamicForm, JtCrud } from 'jtech-webcomps'
import BillingOrderItem from '../billingOrder/BillingOrderItem.vue'
import BillingOrderDialogDeleteOrderItem from './BillingOrderDialogDeleteOrderItem.vue'
import { removeSpecialCharacters } from '../billingOrder/textUtils'

const { page, pageTable, form, input, compositions, composition, modal } =
  JtCrud

@Component({
  mixins: [page],
  name: 'BillingOrderActionPage',
  components: {
    JtDynamicForm,
    page,
    pageTable,
    'crud-form': form,
    'crud-input': input,
    compositions,
    composition,
    modal,
    BillingOrderItem,
    BillingOrderDialogDeleteOrderItem
  },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
class BillingOrderActionPage extends Vue {
  nmInterface = null;
  flSplitModal = false;
  editMode = false
  formsModalSplit = null;
  formsModalSplitButtons = null;
  showBillingOrderItemModal = false;
  billingOrderItemForm = {};
  customCompositions = ['billingOrderItems']
  paramsToDeleteItem = null;
  mounted () {
    this.nmInterface = this.elements[0].nmInterface.split('.')[1]
  }

  totalValue () {
    let total = 0.0
    this.elements[0].dadosForm.billingOrderItems.forEach(billingOrderItem => {
      total += (typeof billingOrderItem.value) == 'string' ? Number(billingOrderItem.value.replaceAll('.', '').replace(',', '.')) : billingOrderItem.value
    })
    return total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
  }

  @Watch('elements')
  onServiceTypeChange () {
    this.totalValue()
  }

  prepareInputs (inputs) {
    this.prepareCompositionsInputs(inputs)
    return inputs
  }

  prepareCompositionsInputs (inputs) {
    inputs.forEach(input => {
      if (this.customCompositions.includes(input.model)) {
        input.allowCustomEditModal = true
      }
    })
  }

  saveSplit () {
    this.flSplitModal = false
  }

  async actionButtonComposition ({ button, formConfig, params }) {
    if (button.name == 'btSplitItems') {
      if (this.forms[0].dadosForm.billingOrderItems.length <= 1) {
        messageBox.warn(this.$gettext('NO_SPLIT_SINGLE_GROUP'))
        return
      }
      this.formsModalSplit = await repository.resolve(
        'billingOrder.splitOrder'
      )
      this.formsModalSplitButtons = this.formsModalSplit[0].buttons
      this.formsModalSplit[0].buttons = []
      this.formsModalSplit[0].inputs[0].buttons[0] = {}
      this.formsModalSplit[0].dadosForm.billingOrderItems =
        this.elements[0].dadosForm.billingOrderItems
      this.flSplitModal = true
    } else if (button.name == 'icAdicionarComposicao') {
      this.editMode = false
      this.billingOrderItemForm = { ...formConfig, dadosForm: { ...formConfig.dadosForm, price: formConfig.dadosForm.price || '0', value: formConfig.dadosForm.value || '0', quantity: formConfig.dadosForm.quantity || '0' } }
      this.showBillingOrderItemModal = true
      this.$refs.billingOrderItemModal.show()
    } else if (button.name == 'icAlterarComposicao') {
      this.editMode = true
      this.billingOrderItemForm = { ...formConfig, dadosForm: { ...formConfig.dadosForm, price: formConfig.dadosForm.price || '0', value: formConfig.dadosForm.value || '0', quantity: formConfig.dadosForm.quantity || '0' } }
      this.showBillingOrderItemModal = true
      this.$refs.billingOrderItemModal.show()
    } else if (button.name == 'icExcluirComposicao') {
      this.paramsToDeleteItem = params
      this.$refs.modalDeleteOrderItem.show()
    }
  }

  async onOkClickDeleteOrderItem (data) {
    try {
      await repository.resolveLogic('billingOrder.newStatus', {
        id: this.paramsToDeleteItem.billingOrder,
        description: data
      })
      this.$refs.modalDeleteOrderItem.hide()
    } catch (error) {
      console.error(error)
    }
  }

  actionButtonModal ({ selectedItems }) {
    const maxGroup = selectedItems
      .map((item) => item.group)
      .reduce((a, b) => Math.max(a, b))
    selectedItems.forEach((element) => {
      element.group = maxGroup + 1
    })
  }

  sumValues (value1, value2) {
    const number1 = this.convertValueToNumber(value1)
    const number2 = this.convertValueToNumber(value2)
    return (Number(number1) + Number(number2))
  }

  convertValueToNumber (value) {
    if (typeof value == 'string') {
      const valueString = value.replace(',', '').replace('.', '')
      const arrayChar = valueString.toString().split('')
      arrayChar.splice(valueString.length - 2, 0, '.')
      return Number(arrayChar.join(''))
    } else {
      return value.toFixed(2)
    }
  }

  onAddBillingOrderItemSuccessHandler (dados) {
    try {
      const registeredProductItem = this.elements[0].dadosForm.billingOrderItems.find(item => item.product == dados.product &&
        item.price == dados.price)
      if (registeredProductItem) {
        registeredProductItem.value = this.sumValues(registeredProductItem.value, dados.value).toLocaleString('pt-br', { minimumFractionDigits: 2 })
        registeredProductItem.quantity = this.sumValues(registeredProductItem.quantity, dados.quantity).toLocaleString('pt-br', { minimumFractionDigits: 2 })

        this.$refs.billingOrderItemModal.hide()
        this.billingOrderItemShow = true
      } else {
        this.elements[0].dadosForm.billingOrderItems.push(dados)
        this.$refs.billingOrderItemModal.hide()
        this.billingOrderItemShow = true
      }
    } catch (error) {
      console.error('onAddBillingOrderItemSuccessHandler', error)
    }
  }

  onEditBillingOrderItemSuccessHandler (dados) {
    try {
      const index = dados.nrLinhaSelecionada
      Object.assign(this.elements[0].dadosForm.billingOrderItems[index], dados)
      this.$refs.billingOrderItemModal.hide()
      this.billingOrderItemShow = true
    } catch (error) {
      console.error('onEditBillingOrderItemSuccessHandler', error)
    }
  }

  get observationInvoice () {
    return this.elements[0].dadosForm.observationInvoice
  }

  @Watch('observationInvoice')
  onObservationInvoiceChange (newVal) {
    this.elements[0].dadosForm.observationInvoice = removeSpecialCharacters(newVal)
  }
}
export default BillingOrderActionPage
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';
.btSaveSplit{
  display:flex;
  justify-content:center;
}
#billing-order-action-page-scoped-container{
  .bt-cancelar{
    .bg-info{
      background-color:#830119 !important;
    }
  }
}
</style>
